import React, { useContext, useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { dashboardColumns } from "./dashboardUtils";
import CustomBreadcrumb from "../../common/CustomBreadcrumb";
import CommonTable from "../../common/CommonTable";
import { useDispatch, useSelector } from "react-redux";
import { getProductHandler } from "../../redux/action/getAllProductSlice";
import { ThemeContext } from "../../common/themeContext";
import {
  addProductAction,
  addProductHandler,
} from "../../redux/action/addProductSlice";
import { getProductFeaturesAction } from "../../redux/action/getproductFeaturesSlice";
import Loader from "../Loder/loader";
import { removeItem, setItem } from "../../common/localStorage";
import { Modal, Switch } from "antd";
import closeIconModal from "../../assets/closeIconModal.svg";
import { Formik, Form, Field, ErrorMessage } from "formik";
import {
  handleKeyPress,
  handleKeyPressSpace,
} from "../../common/CommonFunctions";
import { useCommonMessage } from "../../common/CommonMessage";
import { useAdminPermissions } from "../../hooks/useAdminPermissions";
import { cloneSchema } from "./validationSchema";
import { MODULE_ACCESS_DENIED_MESSAGE } from "../../common/apiResponse";

const Product = () => {
  const [getProduct, setGetProduct] = useState([]);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 100,
    showSizeChanger: true,
    pageSizeOptions: [5, 10, 15, 20],
    className: "order-pagination",
    locale: { items_per_page: "" },
    showTotal: (total, range) => `${range[0]}-${range[1]} of ${total}`,
  });
  // State for Clone Product Modal
  const [showCloneModal, setShowCloneModal] = useState(false);
  const [cloneProductData, setCloneProductData] = useState(null);
  const { theme } = useContext(ThemeContext);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const getAllProductList = useSelector((state) => state?.getAllProductList);
  const addProductSelector = useSelector((state) => state?.addProductDetails);
  const {
    canAddProducts: showAddProduct,
    canEditProducts,
    canViewProducts,
  } = useAdminPermissions();

  const showCloneProduct = showAddProduct;
  const showManageProduct = canEditProducts;
  const showViewProduct = canViewProducts && !canEditProducts;
  const dashBoardColumnsData = dashboardColumns(navigate, {
    onClone: (product) => {
      setCloneProductData(product);
      setShowCloneModal(true);
    },
    showClone: showCloneProduct,
    showManage: showManageProduct,
    showView: showViewProduct,
  });

  const { brandId } = useContext(ThemeContext);

  const handleProductData = (offSet = 1, limit = 10) => {
    window.scrollTo(0, 0);
    const payload = { offSet, limit, refBrandId: brandId };
    if (brandId === 1 || brandId === 2) {
      dispatch(getProductHandler(payload));
    }
  };

  useEffect(() => {
    if (!canViewProducts || !brandId) {
      return;
    }

    handleProductData();
  }, [brandId, addProductSelector, canViewProducts]);

  useEffect(() => {
    const productList = getAllProductList?.data?.data;
    if (productList) {
      const productData = productList?.map(
        ({ id, name, activeStatus, code }) => ({
          productId: id,
          productName: name,
          productStatus:
            activeStatus.charAt(0).toUpperCase() +
            activeStatus?.slice(1).toLowerCase(),
          productCode: code,
        }),
      );
      setGetProduct(productData);
      const { totalElements, pageNumber, pageSize } = getAllProductList?.data;
      setPagination((prevPagination) => ({
        ...prevPagination,
        total: totalElements,
        current: pageNumber,
        pageSize: pageSize,
      }));
    }
  }, [getAllProductList]);

  const addProduct = () => {
    navigate("/addproduct");
    dispatch(addProductAction.addProductSliceInfoReset());
    dispatch(getProductFeaturesAction.getProductFeaturesInfoReset());
    removeItem("productId");
  };

  const handleFormSubmit = (values) => {
    let payload = {
      name: values?.cloneName?.trim(),
      code: values?.cloneCode?.trim(),
      refBrandId: brandId,
      activeStatus: values.cloneStatus ? "ACTIVE" : "INACTIVE",
      fromProductCode: cloneProductData?.productCode,
    };
    dispatch(addProductHandler(payload, { skipForbiddenRedirect: true }));
  };
  const messageApi = useCommonMessage();
  // Success And Error Message
  useEffect(() => {
    if (addProductSelector?.data?.message) {
      messageApi.open({
        type: "success",
        content: addProductSelector?.data?.message,
      });
      // If this was a clone action, set the localStorage flag with the new productId
      if (cloneProductData && addProductSelector?.data?.data?.id) {
        localStorage.setItem("productCloned", addProductSelector.data.data.id);
        setItem("productClonedCode", cloneProductData.productCode);
      }
      setShowCloneModal(false);
      if (cloneFormikRef.current) {
        cloneFormikRef.current.resetForm(); // Reset form only on SUCCESS
      }
      dispatch(addProductAction.addProductSliceInfoReset());
    } else if (addProductSelector?.statusCode === 405) {
      messageApi.open({
        type: "warning",
        content:
          addProductSelector?.message || MODULE_ACCESS_DENIED_MESSAGE,
      });
      setShowCloneModal(false);
      if (cloneFormikRef.current) {
        cloneFormikRef.current.resetForm();
      }
      dispatch(addProductAction.addProductSliceInfoReset());
    } else if (addProductSelector?.message) {
      messageApi.open({
        type: "error",
        content: addProductSelector?.message,
      });
      dispatch(addProductAction.addProductSliceInfoReset());
    }
  }, [addProductSelector, cloneProductData, messageApi, dispatch]);

  // Ref for Formik reset (clone modal)
  const cloneFormikRef = useRef();

  // Clone modal close handler
  const handleCloneModalClose = () => {
    setShowCloneModal(false);
    if (cloneFormikRef.current) {
      cloneFormikRef.current.resetForm();
    }
  };

  // useMemo for dynamic Formik initialValues
  const cloneInitialValues = React.useMemo(
    () => ({
      cloneName: "",
      cloneCode: "",
      cloneStatus:
        cloneProductData &&
        String(cloneProductData.productStatus).toLowerCase() === "active"
          ? true
          : false,
    }),
    [cloneProductData],
  );
  return (
    <>
      {(getAllProductList?.isLoading || addProductSelector?.isLoading) && (
        <Loader loaderTransform="loaderTransform" />
      )}
      {/* Clone Product Modal replaced by Antd Modal */}
      <Modal
        open={showCloneModal}
        onCancel={handleCloneModalClose}
        footer={null}
        closeIcon={null}
        className={
          theme === "healthCare"
            ? "healthcare clone-modal-custom-width"
            : "primecare clone-modal-custom-width"
        }
      >
        <div className="d-flex align-items-center justify-content-between">
          <h2 className="clone-modal-title">Clone Product</h2>
          <img
            src={closeIconModal}
            alt="Close"
            className="cursor-pointer"
            onClick={handleCloneModalClose}
          />
        </div>
        <hr className="my-xl-4 my-3" />
        <div className="clone-modal-info mb-25">
          In order to clone a product you need to enter Product Name or Product
          Code that is unique.
        </div>
        <Formik
          innerRef={cloneFormikRef}
          initialValues={cloneInitialValues}
          enableReinitialize
          validationSchema={cloneSchema}
          onSubmit={(values, { setSubmitting, resetForm }) => {
            handleFormSubmit(values);
          }}
        >
          {({ values, setFieldValue }) => (
            <Form className="login-form">
              <div className="mb-25">
                <label className="mb-2">Product Name*</label>
                <Field
                  name="cloneName"
                  className="form-control"
                  placeholder="Enter your product name"
                  onKeyPress={handleKeyPressSpace}
                  maxLength={30}
                  autoComplete="off"
                />
                <ErrorMessage
                  name="cloneName"
                  component="div"
                  className="error text-danger"
                />
              </div>
              <div className="mb-25">
                <label className="clone-modal-label">Product Code*</label>
                <Field
                  name="cloneCode"
                  className="form-control"
                  placeholder="Product Code"
                  onKeyPress={handleKeyPress}
                  maxLength={50}
                  autoComplete="off"
                />
                <ErrorMessage
                  name="cloneCode"
                  component="div"
                  className="error text-danger"
                />
              </div>
              <div className="d-flex justify-content-between mt-3">
                <div>
                  <div className="productname mb-10 text-nowrap">
                    Product Status
                  </div>
                  <Switch
                    className="switches"
                    checked={values.cloneStatus}
                    onChange={(val) => setFieldValue("cloneStatus", val)}
                  />
                </div>
                <button
                  type="submit"
                  className="ms-auto sbg border-0 py3 fw-18 gbo continuebtn  savebtn"
                >
                  Continue
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </Modal>
      <div className="rightside">
        <div className="rightcontent">
          <p>
            <strong>Products</strong>
          </p>
          <CustomBreadcrumb
            items={[{ text: "Home" }, { text: "Products", active: true }]}
          />

          <div className="table-padding">
            <div className="headtitle">
              <p className="mb-0 heedprodct">Products</p>
              {showAddProduct && (
                <button className="primarybtn" onClick={addProduct}>
                  <div className="plus"></div>
                  Add
                </button>
              )}
            </div>
            <hr className="m-0" />
            <div className="table-responsive">
              <CommonTable
                handlePageChange={handleProductData}
                pagination={pagination}
                body={getProduct}
                columns={dashBoardColumnsData}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Product;
